import React, { useState, useEffect, useContext } from 'react';
import { Form, FormGroup, Input, Label } from 'reactstrap';
import { Btn, H4, P } from '../../../AbstractElements';
import { checkIsAdmin, login, sendPasswordResetEmail } from '../../../firebase/utils'
import { EmailAddress, Password, SignIn } from '../../../Constant';
import { useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import AdminContext from '../../../Helper/admin';
import Loader from '../../../Common/Component/Loader';

const LoginTab = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [togglePassword, setTogglePassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const { setUser } = useContext(AdminContext)
  const history = useNavigate();

  const loginAuth = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const isAdminExist = await checkIsAdmin(email.trim())
      if (isAdminExist) {
        const user = await login(email, password)
        setUser(user)
        history("/")
      } else {
        toast.error('Email not exist')
      }
    } catch (error) {
      if (error.error.includes('auth/wrong-password')) {
        return toast.error('Invalid Password')
      }
      toast.error(error.error);
    } finally {
      setLoading(false);
    }
  };

  const sendEmail = async () => {
    if (!email) return toast.error('Email is required');
    try {
      await sendPasswordResetEmail(email)
      toast.success('Password Reset Email Sent');
    } catch (error) {
      toast.error(error.message);
    }
  }

  return (
    <Form className='theme-form'>
      <H4>{'Sign In'}</H4>
      <P>{'Enter your email & password to login'}</P>
      <FormGroup>
        <Label className='col-form-label'>{EmailAddress}</Label>
        <Input className='form-control' type='email' onChange={(e) => setEmail(e.target.value)} value={email} />
      </FormGroup>
      <FormGroup className='position-relative'>
        <Label className='col-form-label'>{Password}</Label>
        <div className='position-relative'>
          <Input className='form-control' type={togglePassword ? 'text' : 'password'} onChange={(e) => setPassword(e.target.value)} value={password} />
          <div className='show-hide' onClick={() => setTogglePassword(!togglePassword)}><span className={togglePassword ? '' : 'show'}></span></div>
        </div>
      </FormGroup>
      {/* <FormPassword/> */}
      <div className='m-t-30'>
        <Btn
          attrBtn={{
            color: 'primary',
            disabled: loading,
            className: 'd-block w-100 mt-2',
            onClick: (e) => loginAuth(e)
          }}>
          {loading ? <Loader /> : SignIn}
        </Btn>
        <div className='d-flex justify-content-end'><p className='m-t-20' style={{ color: '#5C61F2', fontSize: '14px', cursor: 'pointer' }} onClick={sendEmail}>Forgot Password?</p></div>
        {/* {selected === 'simpleLogin' ? (
            <Btn attrBtn={{ color: 'primary', className: 'd-block w-100 mt-2', onClick: (e) => loginAuth(e) }}>{SignIn}</Btn>
          ) : (
            <Btn attrBtn={{ color: 'primary', className: 'd-block w-100 mt-2', onClick: (e) => loginWithJwt(e) }}>{LoginWithJWT}</Btn>
          )} */}
      </div>
      {/* <div className="login-social-title"><H6>{OrSignInWith}</H6></div>
        <FormHeader selected={selected} /> */}
      <ToastContainer />
    </Form>
  );
};

export default LoginTab;